// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-bridal-luxury-programs',
//   imports: [],
//   templateUrl: './bridal-luxury-programs.html',
//   styleUrl: './bridal-luxury-programs.css',
// })
// export class BridalLuxuryPrograms {

// }

import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApiCallService } from '../../Services/ApiCallService';

export interface CategoryTreatment {
  ID: number;
  Category: string;
  TreatmentName: string;
  Advantages: string | null;
  Image: string | null;
}

@Component({
  selector: 'app-bridal-luxury-programs',            // change per page
  standalone: true,
  imports: [CommonModule, HttpClientModule],
  templateUrl: './bridal-luxury-programs.html',      // change per page
  styleUrl: './bridal-luxury-programs.css',          // change per page
  host: { ngSkipHydration: 'true' },
})
export class BridalLuxuryPrograms implements OnInit {      // change class name per page

  // CHANGE THIS PER PAGE: category name(s) exactly as in the dashboard (capital/small letters don't matter)
  private readonly CATEGORIES = ['BridalLuxuryPrograms', 'Bridal & Luxury Programs'];

  imageBaseUrl = 'https://crm-api.redmonkwellness.com/';   // same as baseImageUrl in home.ts

  treatments: CategoryTreatment[] = [];
  loading = true;

  constructor(private api: ApiCallService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.api.postData('Treatment', 'GetTreatment', {}).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.success) {
          const names = this.CATEGORIES.map(c => this.norm(c));
          this.treatments = (res.TreatmentHistory || [])
            .filter((t: CategoryTreatment) => 
              //names.includes(this.norm(t.Category)))
            //.sort((a: CategoryTreatment, b: CategoryTreatment) => a.ID - b.ID);
              names.includes(this.norm(t.Category)) && Number((t as any).IsActive) === 0)
            .sort((a: CategoryTreatment, b: CategoryTreatment) => a.ID - b.ID);
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  private norm(text: string | null | undefined): string {
    return (text || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  trackById(_: number, t: CategoryTreatment): number {
    return t.ID;
  }

  // /assets/... stays as is, uploaded images get the API url
  imgUrl(path: string | null | undefined): string {
    if (!path) return '/assets/images/treatments/no-image.jpg';
    if (/^https?:\/\//i.test(path) || path.startsWith('data:') || path.startsWith('/assets')) return path;
    return this.imageBaseUrl + path.replace(/^\/+/, '');
  }

  onImgError(event: Event): void {
    (event.target as HTMLImageElement).src = '/assets/images/treatments/no-image.jpg';
  }
}